module.exports = __webpack_public_path__ + "img/jiantou.019119f4.png";